import { useState } from 'react';
import { addHistoryEntry, getHistory, removeHistoryEntry } from '@/dom/historyStorage';
import type { ComparisonResult } from '@/types/domain';
import type { ComparisonSource, FitHistoryEntry } from '@/types/history';

export function useFitHistory() {
  const [history, setHistory] = useState<FitHistoryEntry[]>(() => getHistory());

  function record(source: ComparisonSource, results: ComparisonResult[]) {
    const entry: FitHistoryEntry = { ...source, id: crypto.randomUUID(), createdAt: new Date().toISOString(), results };
    setHistory(addHistoryEntry(entry));
  }

  function remove(id: string) {
    setHistory(removeHistoryEntry(id));
  }

  return { history, record, remove };
}
